import { ActionContext } from 'vuex'
import { RootState } from '@/types/store'
import Vue from 'vue'
// import Plant from '@/models/Plant'

import { createUUID } from '@/helpers/uuid'

interface SnackbarInterface {
  uuid: string | undefined
  timeout: number
  type: string
  message: string
}

const DEFAULT_SNACKBAR = {
  uuid: undefined,
  timeout: 1000 * 5,
  type: 'info',
  message: 'no message',
}

const DEFAULT_SNACKBAR_SUCCESS = {
  uuid: undefined,
  timeout: 1000 * 5,
  type: 'success',
  message: 'no message',
}

const DEFAULT_SNACKBAR_WARNING = {
  uuid: undefined,
  timeout: 1000 * 5,
  type: 'warning',
  message: 'no message',
}

const DEFAULT_SNACKBAR_ERROR = {
  uuid: undefined,
  timeout: 0,
  type: 'error',
  message: 'no message',
}

interface SnackbarState {
  items: SnackbarInterface[]
}

type SnackbarContext = ActionContext<SnackbarState, RootState>

const buildSnackbar = (
  payload: string | object,
  base: SnackbarInterface = DEFAULT_SNACKBAR
): SnackbarInterface => {
  // create item with default settings
  const snackbarItem: SnackbarInterface = Object.assign({}, base)

  // if input is string => set input (string) to message field
  if (typeof payload === 'string' || payload instanceof String) {
    payload = {
      message: payload,
    }
  }

  // add UUID
  snackbarItem.uuid = createUUID()

  // merge defaults with input value
  return Object.assign({}, snackbarItem, payload)
}

const addSnackbar = (
  { commit }: SnackbarContext,
  payload: string | object,
  base: SnackbarInterface = DEFAULT_SNACKBAR
): SnackbarInterface => {
  const snackbarItem = buildSnackbar(payload, base)

  // commit to store
  commit('add', snackbarItem)

  // if timeout => set autoremove
  if (snackbarItem.timeout > 0) {
    setTimeout(() => {
      // console.log('removing snackbar (timer)...')
      commit('remove', snackbarItem.uuid)
    }, snackbarItem.timeout)
  }

  return snackbarItem
}

export default {
  namespaced: true,
  modules: {
    //
  },
  state: () => ({
    items: Array<SnackbarInterface>(),
  }),
  getters: {
    all: (state: SnackbarState) => state.items,
  },
  mutations: {
    remove(state: SnackbarState, uuid: string) {
      Vue.delete(
        state.items,
        state.items.findIndex((s) => s.uuid == uuid)
      )
    },
    add(state: SnackbarState, payload: SnackbarInterface) {
      state.items.push(payload)
    },
  },
  actions: {
    add(context: SnackbarContext, payload: string | object) {
      return addSnackbar(context, payload)
    },
    success(context: SnackbarContext, payload: string | object) {
      return addSnackbar(context, payload, DEFAULT_SNACKBAR_SUCCESS)
    },
    warn(context: SnackbarContext, payload: string | object) {
      return addSnackbar(context, payload, DEFAULT_SNACKBAR_WARNING)
    },
    error(context: SnackbarContext, payload: string | object) {
      return addSnackbar(context, payload, DEFAULT_SNACKBAR_ERROR)
    },
  },
}
